import { useBotStateContext } from '../../../contexts/BotContext';
import usePath from '../../../hook/path/usePath';
import useBlock from '../../../hook/block/useBlock';
import usePathTmp from '../../../hook/path/usePathTmp';
import useShiftKey from '../../../hook/useShiftKey';
// Component for create the first part of the link when you click on it
function BlockLinkEnd({className, style, parent_block_id}) {
    
    const { getBlockInformation } = useBlock();
    const { deletePath } = usePath();
    const { pathTmp } = usePathTmp();
    const { shiftKey } = useShiftKey();
    const { errors } = useBotStateContext();
    const block = errors[parent_block_id];
    var error = false

    className = "in_block " + className + " delete";

    if(block) {
        error = block.errors.filter(child => child.data == undefined && child.type == "block is not link").length ? true : false;
    }  


    // If no path show error
    if(error) {
        className = className + ' part_error ripple'
    }

    const onClick = (e) => {
        if(shiftKey == true) return;
        const {paths_out} = getBlockInformation(parent_block_id);
        if(paths_out.length == 0 || pathTmp != null) {
            return;
        }
        paths_out.forEach(path => deletePath(path.path_id));
    }
    
    const changePathsColor = (color) => {
        const {paths_out} = getBlockInformation(parent_block_id);
        if(paths_out.length == 0 || pathTmp != null) {
            return;
        }

        paths_out.map(path => {
            const pathDom = document.getElementById(path.path_id);
            if(pathDom == null) {
                return;
            }

            pathDom.style.stroke = color
        });
    }

    const onMouseEnter = () => shiftKey == false && changePathsColor("var(--pink)")

    const onMouseLeave = () => shiftKey == false && changePathsColor("")

    return (
        <div className={className} style={{...style}} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}></div>
    )
}

export default BlockLinkEnd;